import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ListModeType } from '@src/app/modules/list-mode-switcher';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramListProduct } from '../../models';

@Component({
  selector: 'lp-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsListComponent extends BaseResizableComponent {
  @Input() products?: readonly LoyaltyProgramListProduct[] | null = null;
  @Input() title?: string;

  @Input() productListMode: ListModeType = 'grid';
  @Input() showIsFavorite: boolean = false;
}
